<template>
  <div class="home">
    <HeroHeader/>
    <!-- <div class="site-content">
           <About/>
     </div> -->
  </div>
</template>

<script>
// @ is an alias to /src
import HeroHeader from '@/components/HeroHeader.vue'
import About from '@/components/About.vue'
export default {
  name: 'Home',
  components: {
    HeroHeader,
    About
  }
}
</script>
